import { useAuth } from '@/services/auth/use-auth'

import { SidebarTrigger } from '@/components/ui/sidebar'

import { SiteHeaderActionUser } from '../site-header'

export function AdminHeader() {
  const user = useAuth((s) => s.user)

  return (
    <header className="sticky top-0 z-10 flex h-16 items-center gap-2 border-b bg-white px-4">
      <SidebarTrigger className="-ml-1" />

      {user?.id && (
        <div className="ml-auto">
          <SiteHeaderActionUser user={user} />
        </div>
      )}
    </header>
  )
}
